import React, { useEffect, useState } from "react";
import useApi from "../utils/useApi";

import Box from "@mui/material/Box";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import "../css/User.css";
import { Autocomplete, TextField } from "@mui/material";
import CloneUser from "./CloneUser";
import ic_new_user from "../img/ic_new_user.png";
import ic_list from "../img/ic_list.png";
import ListOfUsers from "./ListOfUsers";
import ic_edit_user from "../img/ic_edit_user.png";
import UploadSealSignPopup from "./UploadSealSignPopup";
import ViewUploadedSealSignPopup from "./ViewUploadedSealSignPopup";
const Users = () => {
  // const COMPANY_CODE = localStorage?.getItem("companyCode") || "-";
  const [showUploadPopup, setShowUploadPopup] = useState(false);
  const [showViewPopup, setShowViewPopup] = useState(false);

  const [currentDetailsForImageUpload, setCurrentDetailsForImageUpload] =
    useState(null);

  let API_PATHS = localStorage.getItem("apiPaths")
    ? JSON.parse(localStorage.getItem("apiPaths"))
    : "-";

  const BASE_URL = API_PATHS[0]?.API_CONFIG || "https://cubixweberp.com:213";
  const DEPARTMENT = localStorage.getItem("currentSelectedDepartment");
  const [COMPANY_CODE, setCompanyCode] = useState(
    localStorage.getItem("companyCode") || "-",
  );

  useEffect(() => {
    const code = localStorage.getItem("companyCode") || "-";
    setCompanyCode(code);
  }, []);
  const [clickedUserFromList, setClickedUserFromList] = useState(null);
  const [
    selectedEmployeeObjectFromAutoComplete,
    setSelectedEmployeeObjectFromAutoComplete,
  ] = useState(null);

  const [currentUserToBeEdited, setCurrentUserToBeEdited] = useState(null);
  const [selectedUserName, setSelectedUserName] = useState(null);
  const [selectedEmployeeCode, setSelectedEmployeeCode] = useState(null);

  const [showListOfRolesFoRCreation, setShowListOfRolesFoRCreation] =
    useState(false);
  const [typedUsername, setTypedUsername] = useState("");
  const [typedPassword, setTypedPassword] = useState("");
  const [typedSalesmanCode, setTypedSalesmanCode] = useState("");
  const [typedEmployeeCode, setTypedEmployeeCode] = useState(null);
  const [typedUserRole, setTypedUserRole] = useState("");

  const [showClonePopup, setShowClonePopup] = useState(false);
  const [selectedRoleForUserCreation, setSelectedRoleForUserCreation] =
    useState("ALL");

  const [arrayORoles, setArrayORoles] = useState(null);
  const [selectedRole, setSelectedRole] = useState("ALL");

  useEffect(() => {
    console.log("selectedEmployeeCode ", selectedEmployeeCode);
  }, [selectedEmployeeCode]);

  const {
    data: getDataUserRights,
    loading: getLoadingUserRights,
    error: getErrorUserRights,
    get: getUsersUserRights,
  } = useApi();

  const {
    data: getDataforDuplicateCheck,
    loading: getLoadingforDuplicateCheck,
    error: getErrorforDuplicateCheck,
    get: getUsersForDuplicateCheck,
  } = useApi();
  const {
    data: datagetUsersForDuplicateCheckOnSave,
    loading: loadinggetUsersForDuplicateCheckOnSave,
    error: errorgetUsersForDuplicateCheckOnSave,
    get: getUsersForDuplicateCheckOnSave,
  } = useApi();

  const {
    data: getDataSalesmanList,
    loading: getLoadingSalesmanList,
    error: getErrorSalesmanList,
    get: getSalesmanList,
  } = useApi();
  const {
    data: getDataEmployeeList,
    loading: getLoadingEmployeeList,
    error: getErrorEmployeeList,
    get: getEmployeeList,
  } = useApi();
  const {
    data: getDataRoles,
    loading: getLoadingRoles,
    error: getErrorRoles,
    get: getRoles,
  } = useApi();

  const {
    data: getDatagetAllUsersUnderARole,
    loading: getLoadinggetAllUsersUnderARole,
    error: getErrorgetAllUsersUnderARole,
    get: getAllUsersUnderARole,
  } = useApi();

  const {
    data: postData,
    loading: postLoading,
    error: postError,
    post: postUsers,
  } = useApi();

  const [inputValue, setInputValue] = useState("");
  const [loading, setLoading] = useState(false);
  const [statusMessage, setStatusMessage] = useState("");

  useEffect(() => {
    if (postData) {
      console.log("post data", postData);
      if (postData.result?.trim()?.toUpperCase() === "SAVED") {
        alert("Success");
        setInputValue("");
        setLoading(false);

        window.location.reload();
      } else {
        setLoading(false);
      }
    }
  }, [postData]);

  const handleSave = async () => {
    if (currentUserToBeEdited) {
      if (typedUserRole?.trim()?.toUpperCase() === "ALL") {
        alert("please select a role");
        return;
      }
      console.log(
        "handleSave",
        typedUsername,
        typedPassword,
        typedSalesmanCode,
        typedEmployeeCode,
      );

      // removed harcoded checking of role SALESPERSON if they didnt choose salesperson pass blank
      if (
        !typedUsername.trim() ||
        !typedPassword.trim() ||
        !typedEmployeeCode?.trim()
      ) {
        setStatusMessage("Please enter all fields.");
        return;
      }

      setLoading(true);
      setStatusMessage("");

      let arrayToPass = [
        {
          CmpCode: COMPANY_CODE,
          mode: "EDIT",
          loginame: typedUsername,
          loginpwd: typedPassword,
          sales_man: typedSalesmanCode ? typedSalesmanCode?.trim() : "", // pass id of salsperson selected from list ,no need to check role no connection if no salesperson selected from list just pass blank same case when editing if no salesperson selected pass blank
          accessgrp: typedUserRole,
          empcode: typedEmployeeCode,
        },
      ];

      let serializedData = JSON.stringify(arrayToPass);

      postUsers(`${BASE_URL}/api/CRMUserReg`, serializedData, {
        headers: {
          "Content-Type": "application/json",
        },
      });
    } else {
      if (selectedRoleForUserCreation?.trim()?.toUpperCase() === "ALL") {
        alert("please select a role");
        return;
      }
      console.log(
        "handleSave",
        typedUsername,
        typedPassword,
        typedSalesmanCode,
        typedEmployeeCode,
      );

      if (
        !typedUsername.trim() ||
        !typedPassword.trim() ||
        !typedEmployeeCode?.trim()
      ) {
        setStatusMessage("Please enter all fields.");
        return;
      }

      getUsersForDuplicateCheckOnSave(
        `${BASE_URL}/api/CpaysCount/${COMPANY_CODE}/USERLIST/${typedUsername}/-`,
      )
        .then((res) => {
          console.log("res of user dupe check", res);
          if (res.data?.length > 0) {
            alert("username already exists, please change username and SAVE");
            return;
          } else {
            setLoading(true);
            setStatusMessage("");

            let arrayToPass = [
              {
                CmpCode: COMPANY_CODE,
                mode: "ENTRY",
                loginame: typedUsername,
                loginpwd: typedPassword,
                sales_man: typedSalesmanCode ? typedSalesmanCode?.trim() : "",
                accessgrp: selectedRoleForUserCreation,
                empcode: typedEmployeeCode,
              },
            ];

            let serializedData = JSON.stringify(arrayToPass);

            postUsers(`${BASE_URL}/api/CRMUserReg`, serializedData, {
              headers: {
                "Content-Type": "application/json",
              },
            });
          }
        })
        .catch((err) => {
          console.log("res of user dupe check", err);
        });
    }
  };

  useEffect(() => {
    if (!COMPANY_CODE) return;

    getRoles(
      `${BASE_URL}/api/ClientMenuControl/${COMPANY_CODE}/${COMPANY_CODE}/ROLES/-`,
    );

    getEmployeeList(
      `${BASE_URL}/api/PersonalInfoList/${COMPANY_CODE}/ALL/YES/ALL/ALL/ALL/ALL`,
    );

    getSalesmanList(
      `${BASE_URL}/api/MasterCount/${COMPANY_CODE}/SALESPERSONLIST/-/${DEPARTMENT}`,
    );
  }, [COMPANY_CODE]);

  useEffect(() => {
    if (getDataRoles) {
      setArrayORoles([...getDataRoles, { COMPID: "", ROLE: "ALL" }]);
    }
  }, [getDataRoles]);

  useEffect(() => {
    console.log("array of roles ", arrayORoles);
    if (arrayORoles) {
    }
  }, [arrayORoles]);

  // useEffect(() => {
  //   if (!typedUsername || currentUserToBeEdited) return;

  //   const timer = setTimeout(() => {
  //     getUsersForDuplicateCheck(
  //       `${BASE_URL}/api/CpaysCount/${COMPANY_CODE}/USERLIST/${typedUsername}/-`,
  //     );
  //   }, 500); // wait 500ms

  //   return () => clearTimeout(timer);
  // }, [typedUsername, COMPANY_CODE]);

  useEffect(() => {
    if (getDataforDuplicateCheck?.length > 0) {
      alert("username already exists");
    }
  }, [getDataforDuplicateCheck]);

  useEffect(() => {
    console.log(
      "currentUserToBeEdited arrayORoles",
      currentUserToBeEdited,
      arrayORoles,
    );
    if (currentUserToBeEdited) {
      setTypedUsername(currentUserToBeEdited.loginame);
      setTypedPassword(currentUserToBeEdited.loginpwd);
      setTypedEmployeeCode(currentUserToBeEdited.empcode);
      setTypedUserRole(currentUserToBeEdited.accessgrp?.trim());

      let filteredEmployee = getDataEmployeeList?.filter(
        (itemFil) => itemFil.EmpId === currentUserToBeEdited.empcode,
      );

      console.log("filteredEmployee ", filteredEmployee);
      setSelectedEmployeeObjectFromAutoComplete(
        filteredEmployee ? filteredEmployee[0] : null,
      );

      setTypedSalesmanCode(currentUserToBeEdited.sales_man?.trim());
    }
  }, [currentUserToBeEdited]);

  useEffect(() => {
    if (selectedEmployeeObjectFromAutoComplete) {
      setTypedEmployeeCode(selectedEmployeeObjectFromAutoComplete.EmpId);
    }
  }, [selectedEmployeeObjectFromAutoComplete]);

  const uploadImage = async (doctype_from_button_click, doctype_from_click) => {
    // if (!selectedFile) {
    //   console.error("No file selected");
    //   return;
    // }
    // try {
    //   const companyCode = localStorage.getItem("companyCode") || "-";
    //   const apiPaths = JSON.parse(localStorage.getItem("apiPaths")) || [];
    //   const formDataObject = new FormData();
    //   formDataObject.append("DOC_CODE", itemCode || "");
    //   formDataObject.append("DOC_TYPE", "USERSEAL");
    //   formDataObject.append("file", selectedFile);
    //   formDataObject.append("cmpcode", companyCode);
    //   formDataObject.append("IMGBASE64", "test");
    //   formDataObject.append(
    //     "IMAGEPATH",
    //     `${apiPaths[0].IMG_SERVERPATH}\\DOCUMENT_UPLOAD`
    //   );
    //   formDataObject.append("description", "test");
    //   const response = await axios.post(
    //     `${apiPaths[0].IMG_POST_PATH}/api/Image/upload`,
    //     formDataObject,
    //     {
    //       headers: { "Content-Type": "multipart/form-data" },
    //     }
    //   );
    //   showSnackbar("Image uploaded successfully!", "success");
    // } catch (error) {
    //   console.error("Image Upload Failed:", error);
    //   showSnackbar("Failed to upload image!", "error");
    // }
  };

  return (
    <div className=" mx-auto p-6 bg-white rounded shadow-md">
      <div
        className={`fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50 transition-opacity duration-300  ${
          showClonePopup ? "" : "hidden"
        }`}
      >
        <CloneUser
          setShowClonePopup={setShowClonePopup}
          clickedUserFromList={clickedUserFromList}
        />
      </div>

      {currentUserToBeEdited ? (
        <div className="flex items-center mt-6">
          <h2
            className="flex items-center text-xl text-blue-500 "
            style={{ color: "#00ACC1" }}
          >
            <img className="w-10 me-2" src={ic_edit_user} />
            Edit User
          </h2>
          <button
            onClick={() => setCurrentUserToBeEdited(null)}
            className="ms-5 bg-gray-100 text-gray-500 p-2 rounded"
          >
            Cancel
          </button>
        </div>
      ) : (
        <h2
          className="flex items-center text-xl text-blue-500 mt-6"
          style={{ color: "#209254" }}
        >
          <img className="w-10 me-2" src={ic_new_user} /> Create User
        </h2>
      )}

      <div className="flex flex-wrap mt-4">
        {currentUserToBeEdited ? (
          <div className="flex items-center">
            <label>{currentUserToBeEdited.loginame}</label>
          </div>
        ) : (
          <div className="flex">
            <div
              style={{ minWidth: "200px" }}
              className="flex relative flex-col"
            >
              <h3
                className="text-gray-500 flex"
                style={{ width: "100px", padding: "   0px" }}
              >
                Select Role
              </h3>

              <span
                className="border rounded border-gray-500 text-gray-500 px-2 flex items-center justify-between mt-2"
                onClick={() => setShowListOfRolesFoRCreation((prev) => !prev)}
              >
                {selectedRoleForUserCreation}
                <svg
                  className="ms-1"
                  width="20"
                  height="10"
                  viewBox="0 0 10 6"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M1 1L5 5L9 1"
                    stroke="currentColor"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </span>

              {showListOfRolesFoRCreation && (
                <div
                  className="shadow border"
                  style={{
                    backgroundColor: "#ffffff",
                    width: "200px",
                    height: "200px",
                    position: "absolute",
                    padding: "10px",
                    left: "0px",
                    top: "60px",
                    overflowY: "scroll",
                    zIndex: 3,
                  }}
                >
                  <div>
                    {arrayORoles?.map((item) => {
                      return (
                        <p
                          className="border-b p-2"
                          onClick={() => {
                            setShowListOfRolesFoRCreation(false);
                            setSelectedRoleForUserCreation(item.ROLE);
                          }}
                        >
                          {item.ROLE}
                        </p>
                      );
                    })}
                  </div>
                </div>
              )}
            </div>
            <input
              type="text"
              placeholder="Enter username"
              value={typedUsername}
              onChange={(e) => setTypedUsername(e.target.value)}
              className=" border border-gray-300 rounded px-3 py-2 ms-2"
            />
          </div>
        )}

        <input
          type="text"
          placeholder="Enter Password"
          value={typedPassword}
          onChange={(e) => setTypedPassword(e.target.value)}
          className=" border border-gray-300 rounded px-3 py-2 ms-4"
        />

        {currentUserToBeEdited && (
          <div className="ms-2">
            <Box sx={{ minWidth: 150 }}>
              <FormControl fullWidth size="small">
                <InputLabel id="editt-role-label">Role</InputLabel>
                <Select
                  sx={{ height: 55 }}
                  labelId="editt-role-label"
                  id="ROLE"
                  value={typedUserRole ? typedUserRole?.trim() : ""}
                  label="Salesman"
                  onChange={(event) =>
                    setTypedUserRole(event.target.value?.trim())
                  }
                >
                  {arrayORoles?.map((item) => {
                    return (
                      <MenuItem value={item.ROLE?.trim()}>{item.ROLE}</MenuItem>
                    );
                  })}
                </Select>
              </FormControl>
            </Box>
          </div>
        )}

        {
          <div className="ms-2">
            <Box sx={{ minWidth: 150 }}>
              <FormControl fullWidth size="small">
                <InputLabel id="saleman-label">Sales person</InputLabel>
                <Select
                  sx={{ height: 55 }}
                  labelId="saleman-label"
                  id="EMP_ID"
                  value={typedSalesmanCode ? typedSalesmanCode : ""}
                  label="Salesman"
                  onChange={(event) => setTypedSalesmanCode(event.target.value)}
                >
                  <MenuItem value="">
                    <em>Select employee</em>
                  </MenuItem>
                  {getDataSalesmanList?.map((item) => {
                    return <MenuItem value={item.EMP_ID}>{item.NAME}</MenuItem>;
                  })}
                </Select>
              </FormControl>
            </Box>
          </div>
        }

        <div className="ms-2">
          <Autocomplete
            sx={{ width: "300px" }}
            options={getDataEmployeeList}
            value={selectedEmployeeObjectFromAutoComplete}
            getOptionLabel={(option) => (option.Name ? option.Name : "")}
            onChange={(event, newValue) => {
              console.log("selected employee", newValue);
              setSelectedEmployeeObjectFromAutoComplete(newValue);
            }}
            renderInput={(params) => (
              <TextField
                {...params}
                label="Select Employee"
                variant="outlined"
              />
            )}
            filterOptions={(options, { inputValue }) =>
              options.filter(
                (option) =>
                  option.EmpId.toLowerCase().includes(
                    inputValue.toLowerCase(),
                  ) ||
                  option.Name.toLowerCase().includes(inputValue.toLowerCase()),
              )
            }
          />
        </div>
        <button
          onClick={handleSave}
          disabled={loading}
          className="ms-3 bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700 disabled:opacity-50"
        >
          {loading ? "Saving..." : "Save"}
        </button>
      </div>
      {statusMessage && (
        <div className="mt-4 text-bold text-red-700">{statusMessage}</div>
      )}

      <ListOfUsers
        setCurrentUserToBeEdited={setCurrentUserToBeEdited}
        setShowClonePopup={setShowClonePopup}
        setClickedUserFromList={setClickedUserFromList}
        setShowUploadPopup={setShowUploadPopup}
        setCurrentDetailsForImageUpload={setCurrentDetailsForImageUpload}
        setShowViewPopup={setShowViewPopup}
      />

      <UploadSealSignPopup
        isOpen={showUploadPopup}
        onClose={() => setShowUploadPopup(false)}
        currentDetailsForImageUpload={currentDetailsForImageUpload}
      />

      <ViewUploadedSealSignPopup
        isOpen={showViewPopup}
        onClose={() => setShowViewPopup(false)}
        currentDetailsForImageUpload={currentDetailsForImageUpload}
        title="View Seal"
      />
    </div>
  );
};

export default Users;
